import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { SpeseLegaliForm } from "../../../form/spese-legali-form/spese-legali-form";
import { SpesaLegale } from "../../../models/tipologiche/spesa-legale";
import { FormValidationService } from '../../../services/form-validation.service';
import { SpeseLegaliAdapter } from './spese-legali-adapter';

declare var closeModal: any;

@Component({
  selector: 'div [spese-legali-form-add]',
  templateUrl: '../../../form/spese-legali-form/spese-legali-form.html',
})

export class SpeseLegaliFormAddComponent extends SpeseLegaliForm implements OnInit {
  urlAggiungiSpesa: string;
  @Output() onReturn: EventEmitter<SpesaLegale> = new EventEmitter<SpesaLegale>();
  @Input() tipoPetitium: string;

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService, @Inject(FormValidationService) formValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }
  ngOnInit() {
    this.isInserimento(true);
  }

  getAdapter(): SpesaLegale {
    return new SpeseLegaliAdapter(new SpesaLegale()).spesaLegale;
  }

  getRequest(spesaLegale: SpesaLegale) {
    this.onReturn.emit(spesaLegale);
  }

  inizializza(tipoPetitium: string) {
    this.populateSelect();
    this.createForm(tipoPetitium);
  }
}
